import {NotificationCategoryType} from '../../../pages/notification/constants/notificationCategoryItems';
import request from '../../axios';
import {NotificationListResponse} from './type';

export const getNotificationsList = async (
  page: number = 1,
  category?: NotificationCategoryType,
): Promise<NotificationListResponse> => {
  const params: Record<string, any> = {page};

  // Only add category if it's not 'All' or undefined
  if (category && category !== 'All') {
    params.category = category;
  }

  const {data} = await request.get<NotificationListResponse>(
    `api/v2/notification/list-store-notification`,
    {params},
  );

  return data;
};
